import React from 'react';
import factory from 'smart-table-react';

export default factory(React);
